import PropTypes from "prop-types";
import * as React from "react";
import { Select, TextInput } from "../../themeV2";
import css from "./CropStep.module.css";

const NO_ROLE = "";

const roleLabel = ({ character_name: name, franchise_name: franchise }) =>
  franchise ? `${name} (${franchise})` : name;

export default function CharacterDetailsFields({
  label,
  influencerCharacterId,
  roles,
  onDetailsChange,
}) {
  return (
    <div className={css.details}>
      <TextInput
        variant="filled"
        label="Character name (optional)"
        description="Shown on cards instead of the role's name."
        value={label ?? ""}
        onValueChange={(value) =>
          onDetailsChange({ label: value === "" ? null : value })
        }
      />
      <Select.Root
        label="Role"
        description="Links this image to one of the shop's roles."
        value={influencerCharacterId ?? NO_ROLE}
        onValueChange={(value) =>
          onDetailsChange({
            influencerCharacterId: value === NO_ROLE ? null : value,
          })
        }
      >
        <Select.Item value={NO_ROLE} label="None">
          None
        </Select.Item>
        {roles.map((role) => (
          <Select.Item
            key={role.influencer_character_id}
            value={role.influencer_character_id}
            label={roleLabel(role)}
          >
            {roleLabel(role)}
          </Select.Item>
        ))}
      </Select.Root>
    </div>
  );
}

CharacterDetailsFields.propTypes = {
  label: PropTypes.string,
  influencerCharacterId: PropTypes.number,
  roles: PropTypes.arrayOf(PropTypes.object).isRequired,
  onDetailsChange: PropTypes.func.isRequired,
};
